var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function mapReducersOrEffectsToCreaters(namespace, object) {
    var actionCreaters = {};
    var _loop_1 = function (key) {
        actionCreaters[key] = function (payload, noNS, extData) {
            if (noNS === void 0) { noNS = false; }
            if (extData === void 0) { extData = {}; }
            return __assign({ type: namespace && !noNS ? namespace + "/" + key : key, payload: payload }, extData);
        };
    };
    for (var key in object) {
        _loop_1(key);
    }
    return actionCreaters;
}
/**
 * 始终使用 createActionCreaters 创建 action，才能保证 store 定义和业务调用的类型一致。
 */
export function createActionCreaters(model) {
    return {
        reducers: mapReducersOrEffectsToCreaters(model.namespace, model.reducers),
        effects: mapReducersOrEffectsToCreaters(model.namespace, model.effects),
    };
}
